import { render, staticRenderFns } from "./PurE_Delivery.vue?vue&type=template&id=8139e362"
import script from "./PurE_Delivery.vue?vue&type=script&lang=js"
export * from "./PurE_Delivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports